/**
 * Report a successful add-to-bag that did not go through the Luma ajax path (the e-gift
 * card page adds with `fetch`) to the Triple Whale add-to-bag binding
 * (`BBNT_TripleWhaleEvents/js/tw-add-to-cart`), which is started on every page by the
 * module. The binding asks the identity transport for the touched cart lines and fires
 * one `AddToCart` per line; before it is started, or when the module is absent, nothing
 * is reported and the promise resolves to 0. Never throws: analytics must not break the
 * purchase flow.
 */

export interface TripleWhaleAddedLine {
  product_id: string | number;
  qty: number;
}

interface TripleWhaleAddToCartBinding {
  trackAdded: (items: TripleWhaleAddedLine[]) => Promise<number>;
}

const BINDING_MODULE_ID = "BBNT_TripleWhaleEvents/js/tw-add-to-cart";

export const trackTripleWhaleAdded = (
  items: TripleWhaleAddedLine[]
): Promise<number> => {
  const requirejs = (window as any).require;
  if (typeof requirejs !== "function" || !items.length) {
    return Promise.resolve(0);
  }
  return new Promise<number>((resolve) => {
    try {
      requirejs(
        [BINDING_MODULE_ID],
        (binding: TripleWhaleAddToCartBinding) => {
          Promise.resolve(binding.trackAdded(items))
            .then((fired) => resolve(typeof fired === "number" ? fired : 0))
            .catch(() => resolve(0));
        },
        () => resolve(0)
      );
    } catch (error) {
      resolve(0);
    }
  });
};
